import { NoticeTalkRoomRequest } from "@/apiRequests/models/communityTalk/noticeTalkRoomRequest";
import MailReceiveApiRequest from "@/apiRequests/resources/communityTalk/mailReceiveApiRequest";

/**
 * メール通知周りのDomain。
 */
export default class MailReceiveDomain {
	private readonly _mailReceiveApiRequest: MailReceiveApiRequest;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._mailReceiveApiRequest = new MailReceiveApiRequest();
	}

	/**
	 * メール通知リクエスト送付APIへのリクエスト。
	 * @param tenantId 対象のテナントID。
	 * @param talkRoomId 対象のトークルームID。
	 * @param mailAddress 通知先メールアドレス。
	 * @param publishCookieId ReviCoCookieId。
	 * @param siteUserId サイトのユーザーID。
	 */
	public async postNoticeTalkRoom(tenantId: string, talkRoomId: string, mailAddress: string, publishCookieId: string, siteUserId?: string): Promise<string> {
		// APIリクエスト用にデータ成形
		const request: NoticeTalkRoomRequest = {
			tenantId: tenantId,
			talkRoomId: talkRoomId,
			mailAddress: mailAddress,
			publishCookieId: publishCookieId,
			tenantMemberCd: siteUserId,
		};
		return await this._mailReceiveApiRequest.postNoticeTalkRoom(tenantId, request);
	}
}
